import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';

interface ScheduleSlotButtonProps {
  start: string;
  className?: string;
  dataTestId?: string;
  onClick: () => void;
}

export function ScheduleSlotButton({
  start,
  className,
  dataTestId = DataTestIdEnum.SEARCH_CARD_CLINIC_SCHEDULED_SLOT_BUTTON,
  onClick,
}: ScheduleSlotButtonProps) {
  return (
    <Button
      variant="secondary"
      color="primary"
      className={cn('py-1.5 xl:py-2 text-sm xl:text-base', className)}
      data-testid={dataTestId}
      onClick={onClick}
    >
      {start}
    </Button>
  );
}
